// extracted by mini-css-extract-plugin
module.exports = {"layout-container":"Layout_layout-container__2I_KI","main-container":"Layout_main-container__IA2rd","no-margin":"Layout_no-margin__JKoDg"};